import { UNADJUST_BILL_PURCHASE_RETURN_REGISTER_REPORT_FAILURE, UNADJUST_BILL_PURCHASE_RETURN_REGISTER_REPORT_REQUEST, UNADJUST_BILL_PURCHASE_RETURN_REGISTER_REPORT_SUCCESS } from "../types";
  
  const initialState = {
    unadjustBillPurchaseReturReport: {},
    loading: false,
    error: null,
  };
  
  const unadjustBillPurchaseReturnReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case UNADJUST_BILL_PURCHASE_RETURN_REGISTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case UNADJUST_BILL_PURCHASE_RETURN_REGISTER_REPORT_SUCCESS: {
        console.log("UNADJUST_BILL_PURCHASE_RETURN_ Purchase Return Payload",action.payload);
        
        return {
          ...state,
          unadjustBillPurchaseReturnReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case UNADJUST_BILL_PURCHASE_RETURN_REGISTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default unadjustBillPurchaseReturnReportReducer;
  